<template>
  <div>
    <select
      :id="id"
      class="input appearance-none bg-[length:1rem] bg-[right_0.75rem_center] bg-no-repeat pr-9"
      :class="{ 'input-error': invalid }"
      :style="chevron"
      :disabled="disabled || loading || !!failure"
      :value="modelValue === null ? '' : modelValue"
      @change="onChange"
    >
      <option v-if="blank || !required" value="">{{ loading ? 'Chargement…' : blank || placeholder }}</option>
      <option v-else value="" disabled>{{ loading ? 'Chargement…' : placeholder }}</option>
      <option v-for="o in options" :key="o.value" :value="o.value">{{ o.label }}</option>
    </select>
    <p v-if="failure" class="mt-1 text-xs text-rose-600">
      {{ failure }} <button type="button" class="font-semibold underline" @click="load">Réessayer</button>
    </p>
  </div>
</template>

<script>
import { loadLookup } from '@/api/lookups'

const CHEVRON =
  "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%2364748B' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'/%3E%3C/svg%3E\")"

export default {
  name: 'LookupSelect',
  props: {
    modelValue: { type: [Number, String], default: '' },
    /** Clé de liste de référence (vehicles, drivers, owners…) — voir api/lookups.js. */
    lookup: { type: String, default: '' },
    /** Ou une liste statique [{ value, label }]. */
    staticOptions: { type: Array, default: null },
    onlyWhere: { type: Function, default: null },
    placeholder: { type: String, default: 'Sélectionner…' },
    /** Libellé de l'option vide (ex. « Tous les véhicules »). */
    blank: { type: String, default: '' },
    required: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    invalid: { type: Boolean, default: false },
    id: { type: String, default: undefined }
  },
  emits: ['update:modelValue'],
  data() {
    return { options: [], loading: false, failure: '', chevron: { backgroundImage: CHEVRON } }
  },
  watch: {
    lookup() {
      this.load()
    }
  },
  created() {
    this.load()
  },
  methods: {
    async load() {
      if (this.staticOptions) {
        this.options = this.staticOptions
        return
      }
      if (!this.lookup) return
      this.loading = true
      this.failure = ''
      try {
        this.options = await loadLookup(this.lookup, { onlyWhere: this.onlyWhere })
      } catch (e) {
        this.failure = e.status === 403 ? "Liste non accessible avec vos droits." : 'Chargement impossible.'
      } finally {
        this.loading = false
      }
    },
    onChange(event) {
      const raw = event.target.value
      if (raw === '') return this.$emit('update:modelValue', '')
      const match = this.options.find((o) => String(o.value) === raw)
      this.$emit('update:modelValue', match ? match.value : raw)
    }
  }
}
</script>
